module.exports = __webpack_public_path__ + "img/single-vel-info2.cb64f01c.png";